<template>
  <div id="platform">
    <div class="blueInfo">
      <p>
        * 提现规则按照机构配置，可配置该机构司机余额提现日期、时间、次数及金额大小。
      </p>
    </div>
    <custom-table
      :has-organization="false"
      ref="customTable"
      :customOptions="customOptions"
      :columns="columns"
      :refreshShow="false"
      labelWidth="135"
      style="height: calc(100vh - 210px)"
    >
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'applyStartTime'">
          <span>{{ row.applyStartTime }} - {{ row.applyEndTime }}</span>
        </template>
        <template v-else-if="item.prop === 'earningsFreezeTime'">
          <span :style="{color: row.earningsFreeze == 1 ? '#666' : '#aaa'}">{{ row.earningsFreeze == 1 ? `${row.earningsFreezeTime}天` : '未开启' }}</span>
        </template>
        <template v-else-if="item.prop === 'applyAmountMax'">
          <span v-if="row.applyAmountMin && row.applyAmountMax">{{row.applyAmountMin}}元~{{ row.applyAmountMax }}元</span>
          <span v-else>-</span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
      <template slot="table-operation" v-if="btnPreFn(routeName+'_edit', false)">
        <el-table-column label="操作" width="140px" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="editD(row)">编辑</el-button>
          </div>
        </el-table-column>
      </template>
    </custom-table>

    <el-dialog destroy-on-close :visible.sync="visible" title="司机提现配置" width="550px"
               :before-close="handClose">
      <driverWithdrawal @handClose="handClose" type="1" :rowData="rowDate" v-if="visible"></driverWithdrawal>
    </el-dialog>
  </div>
</template>


<script>
export default {
  name: "platform",
  components: {
    driverWithdrawal: () => import('./components/driverWithdrawal.vue')
  },

  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/airport/withdrawalConfig",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
          type: 1
        },
        search: [],
      },
      // 表头
      columns: [
        { prop: "organizationName", label: "机构名称" },
        { prop: "earningsFreezeTime", label: "收益冻结" },
        { prop: "windowPhase", label: "日期窗口",minWidth: 160 },
        { prop: "applyStartTime", label: "时间窗口" },
        { prop: "applyNum", label: "每日提现次数" },
        { prop: "applyAmountMax", label: "单次提现限额" },
      ],
      rowDate: {},
      visible: false
    };
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
  },
  
  methods: {
    handClose(){
      this.rowDate = {}
      this.visible = false
      this.$refs.customTable.listFn();
    },
    editD(row) {
      this.rowDate = {
        ...row
      }
      this.visible = true
    }

  },
};
</script>

<style lang="less">
#platform {
  .el-radio-item .el-radio__label {
    font-weight: 600;
    color: #222222;
  }

  .el-radio-item + .el-radio-item {
    padding-top: 8px;
  }

  .el-radio-item .el-form-item-remark {
    padding-top: 8px;
  }

  .block {
    width: 800px;
    padding-bottom: 80px;

    .add {
      width: 100%;
      padding: 10px;
      margin-top: 20px;
      border: 1px #dcdfe6 dashed;
    }
  }
}
</style>
